import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { provideFeatureToggles } from '@spartacus/core';

@NgModule({
  declarations: [],
  imports: [
    CommonModule,
  ],
  providers: [
    provideFeatureToggles({
      a11yAddedToCartActiveDialog: true,
      a11yAddToWishlistFocus: true,
      a11yAnonymousConsentMessageInDialog: true,
      a11yApprovalProcessWithNoClearable: true,
      a11yCarouselArrowKeysNavigation: true,
      a11yCartImportConfirmationMessage: true,
      a11yCheckoutStepsLandmarks: true,
      a11yCroppedFocusRing: true,
      a11yDeleteButton2First: true,
      a11yDeliveryMethodFieldset: true,
      a11yDialogsHeading: true,
      a11yDialogTriggerRefocus: true,
      a11yDifferentiateFocusedAndSelected: true,
      a11yFocusOnCardAfterSelecting: true,
      a11yHamburgerMenuTrapFocus: true,
      a11yHideConsentButtonWhenBannerVisible: true,
      a11yHighContrastBorders: true,
      a11yImproveButtonsInCardComponent: true,
      a11yImprovedErrorMessage: true,
      a11yItemCounterFocus: true,
      a11yKeyboardFocusInSearchBox: true,
      a11yMiniCartFocusOnMobile: true,
      a11yMobileFocusOnFirstNavigationItem: true,
      a11yNavigationButtonsAriaFixes: true,
      a11yNavMenuExpandStateReadout: true,
      a11yNgSelectAriaLabelDropdownCustomized: true,
      a11yNgSelectCloseDropdownOnEscape: true,
      a11yNgSelectLayering: true,
      a11yNgSelectOptionsCount: true,
      a11yOptimizedMenuSpacing: true,
      a11yPasswordVisibliltyBtnValueOverflow: true,
      a11yPdpGridArrangement: true,
      a11yPickupOptionsTabs: true,
      a11yPopoverHighContrast: true,
      a11yPostRegisterSuccessMessage: true,
      a11yPreventHorizontalScroll: true,
      a11yQTY2Quantity: true,
      a11yQuickOrderAriaControls: true,
      a11yQuickOrderSearchBoxRefocusOnClose: true,
      a11yQuickOrderSearchListKeyboardNavigation: true,
      a11yRegionAssociatedHeaders: true,
      a11yRemoveStatusLoadedRole: true,
      a11yRepeatedCancelOrderError: true,
      a11yRepeatedPageTitleFix: true,
      a11yRepeatingButtonsUniqueLabels: true,
      a11yResetFocusAfterNavigating: true,
      a11yScrollToReviewByShowReview: true,
      a11yScrollToTopPositioning: true,
      a11ySearchableDropdownFirstElementFocus: true,
      a11ySearchboxAssistiveMessage: true,
      a11ySearchBoxFocusOnEscape: true,
      a11ySearchboxLabel: true,
      a11ySelectImprovementsCustomerTicketingCreateSelectbox: true,
      a11ySelectLabelWithContextForSelectedAddrOrPayment: true,
      a11yShowDownArrowOnFocusedSelectMenu: true,
      a11yShowLabelOfSelect: true,
      a11yShowMoreReviewsBtnFocus: true,
      a11yStoreInStockIconContrast: true,
      a11yStyleExternalLinksAsLinks: true,
      a11yTabComponent: true,
      a11yTableHeaderReadout: true,
      a11yTabsManualActivation: true,
      a11yTextSpacingAdjustments: true,
      a11yTruncatedTextStoreFinder: true,
      a11yTruncatedTextUnitLevelOrderHistory: true,
      a11yUpdatingCartNoNarration: true,
      a11yUseProperTextColorForFutureStockAccordion: true,
      a11yUseTrapTabInsteadOfTrapInDialogs: true,
      a11yViewHoursButtonIconContrast: true,
      a11yWideScreenImprovements: true,
      a11yWrapReviewOrderInSection: true,
      updateConsentGivenInOnChanges: true,
    }),
  ],
})
export class A11yFeaturesModule {}
